<template>
  <auth-layout>
    <v-container class="flex-1 flex flex-col justify-center items-center">
      <div class="md:flex transform -translate-y-20">
        <div class="text-4xl font-bold mr-4 text-yellow-600">404</div>
        <div>
          <h1 class="text-4xl font-bold">Pagina nu a fost gasita.</h1>
          <h2 class="text-xl text-gray-400 mt-2">
            Ne pare rau, nu am putut gasi pagina pe care o cautati.
          </h2>
          <router-link
            to="/"
            class="
              inline-block
              mt-6
              px-5
              py-2
              bg-yellow-600
              text-white
              rounded-md
            "
            >Acasa</router-link
          >
        </div>
      </div>
    </v-container>
  </auth-layout>
</template>

<script>
import AuthLayout from "../layout/AuthLayout.vue";
import VContainer from "../components/VContainer.vue";
export default {
  components: { AuthLayout, VContainer },
};
</script>

<style></style>
